import client from '../client';
import { IamAccount } from '../models';

/**
 * Get the IAM account of the user
 * @param {string} accountId The account ID
 * @param {string} accessToken The access token for authentication
 * @returns {Promise<IamAccount>} A promise that resolves the IAM account
 */
export const getAccount = async (accountId: string, accessToken: string): Promise<IamAccount> => {
  const response = await client.get(`/${accountId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return response.data;
};
